<template>
  <div class="summary-field">
    <span class="summary-field__label">{{ label }}</span>
    <div class="summary-field__value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: 'SummaryField',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .summary-field {
    margin-bottom: 36px;
    width: 100%;

    &__label {
      color: $primary;
      display: block;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    &__value {
      align-items: center;
      background-color: rgba(229, 231, 239, .25);
      border-radius: 12px;
      border: 1px solid rgba(229, 231, 239, .8);
      color: #525878;
      display: flex;
      font-size: 13px;
      font-weight: 500;
      height: 50px;
      letter-spacing: .3px;
      padding: 0 20px;
    }
  }
</style>
